module.exports = __webpack_public_path__ + "static/kelsie-2-7be45131288e844bfafc0ffe439e0d36.jpg";